import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../lib/session.js';
import { AppShell } from './AppShell.js';

/**
 * Gate around every authenticated route. Where the visitor was heading is
 * carried into the login route so they land there instead of on the overview
 * after signing in.
 */
export function RequireSession(): ReactElement {
  const { isSignedIn } = useSession();
  const location = useLocation();

  if (!isSignedIn) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <AppShell />;
}
